import React, { lazy } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

//material UI
import { Grid } from "@mui/material";

//images
import Error404 from "./../../images/404-error.svg";
import Error404__placeholder from "../../images/404-error_placeholder.png";

//components
const MyGenderHeader = lazy(() => import("../../components/Header/mygender"));
const CustomButton = lazy(() => import("../../components/Button"));

export default function GenericAppError() {
  return (
    <Grid container spacing={2} sx={{ overflow: "auto", height: "100vh" }}>
      <Grid item xs></Grid>
      <Grid item xs={10}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <MyGenderHeader />
          </Grid>
          <Grid item xs={12}>
            <LazyLoadImage
              loading="lazy"
              src={Error404}
              placeholderSrc={Error404__placeholder}
              width={"100%"}
              height={"auto"}
              alt="Erro 404! Página não encontrada."
            />
          </Grid>
          <Grid item xs={12} sx={{ textAlign: "center" }}>
            <CustomButton
              width={"5.5em"}
              height={"4.625em"}
              type={"RefreshIcon"}
              backcolor={"#EDE838"}
              path={"/"}
            ></CustomButton>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs></Grid>
    </Grid>
  );
}
